import { useState } from "react";
import type { Auth } from "../../lib/auth";

export function SignIn({ auth, note }: { auth: Auth; note?: string | undefined }) {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(note ?? null);

  async function go(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setMsg(null);
    const slow = setTimeout(() => setMsg("Still connecting to the sign-in server…"), 6000);
    const r = await auth.signIn(email, pass);
    clearTimeout(slow);
    setBusy(false);
    if (!r.ok) setMsg(r.message);
  }

  return (
    <div className="signin-wrap">
      <form className="signin" onSubmit={go}>
        <h1>REI CRM</h1>
        <p className="tag">v2 · fast + offline-first</p>
        <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" />
        <input type="password" required placeholder="Password" value={pass} onChange={(e) => setPass(e.target.value)} autoComplete="current-password" />
        <button disabled={busy}>{busy ? "Signing in…" : "Sign in"}</button>
        {msg ? <div className="note">{msg}</div> : null}
      </form>
    </div>
  );
}
